import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

import StickerBoard from '../views/sticker_board/ClientView.vue';
import AvaibleGames from '../views/available_games/ClientView.vue';
import Promotions from '../views/promotions/ClientView.vue';
import Winnings from '../views/winnings/ClientView.vue';

import PickABox from '../views/available_games/game_launcher/pick_a_box/LandingPage.vue';

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/stickerboard',
    name: 'StickerBoard',
    component: StickerBoard
  },
  {
    path: '/winnings',
    name: 'Winnings',
    component: Winnings
  },
  {
    path: '/promotions',
    name: 'Promotions',
    component: Promotions
  },
  {
    path: '/avaiblegames',
    name: 'AvaibleGames',
    component: AvaibleGames
  },
  {
    path: '/avaiblegames/pickabox',
    name: 'PickABox',
    component: PickABox
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router